// Customer accounts: sign up, log in, forgot / reset password.
// Talks to the iPOINT backend (REACT_APP_API_URL). No Firebase, no Google, no OTP.
// The customer's token is kept under its own key, separate from the admin token.

const API = (
  process.env.REACT_APP_API_URL ||
  'https://ipointshop-com-127859.hostingersite.com'
).replace(/\/$/, '')
const TOKEN_KEY = 'ipoint-user-token'
const USER_KEY = 'ipoint-user'

const read = (k) => { try { return localStorage.getItem(k) } catch { return null } }
const write = (k, v) => { try { localStorage.setItem(k, v) } catch {} }
const drop = (k) => { try { localStorage.removeItem(k) } catch {} }

export const getToken = () => read(TOKEN_KEY) || ''
export const readCachedUser = () => { try { return JSON.parse(read(USER_KEY)) } catch { return null } }
export const saveUser = (user) => write(USER_KEY, JSON.stringify(user))
export const saveSession = (token, user) => { write(TOKEN_KEY, token); saveUser(user) }
export const clearSession = () => { drop(TOKEN_KEY); drop(USER_KEY) }

async function call(path, { method = 'GET', body } = {}) {
  const headers = {}
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`
  if (body) headers['Content-Type'] = 'application/json'

  let res
  try {
    res = await fetch(`${API}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined })
  } catch {
    throw new Error('Cannot reach the server. Check your internet connection and try again.')
  }
  let data = null
  try { data = await res.json() } catch { /* empty reply */ }
  if (!res.ok) {
    const err = new Error((data && data.message) || 'Something went wrong. Please try again.')
    err.status = res.status
    throw err
  }
  return data
}

// { name, email, phone, password, confirm_password } -> { token, user }
export const apiSignUp = (f) => call('/customers/signup', { method: 'POST', body: f })
export const apiLogIn = (email, password) => call('/customers/login', { method: 'POST', body: { email, password } })
export const fetchMe = () => call('/customers/me')
export const apiForgot = (email) => call('/customers/forgot-password', { method: 'POST', body: { email } })
export const apiReset = (token, password, confirm_password) =>
  call('/customers/reset-password', { method: 'POST', body: { token, password, confirm_password } })

export const signOutUser = () => { clearSession(); return Promise.resolve() }
export const friendly = (e) => e?.message || 'Something went wrong. Try again.'
export const USING_FIREBASE = false // kept so older imports do not break